import { IAccount } from '@topshots/core-models';
import { topshotsAPI } from '../../app/api';

const accountsApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    ensureAccountInfra: build.mutation<void, void>({
      query: () => ({
        url: 'accounts/ensure',
        method: 'POST',
      }),
    }),
    getAccounts: build.query<IAccount[], void>({
      query: (request) => ({
        url: 'accounts',
        method: 'GET',
      }),
      providesTags: (result, error, page) =>
        result
          ? [
              // Provides a tag for each enquiry in the current page,
              // as well as the 'PARTIAL-LIST' tag.
              ...result.map(({ _id }) => ({
                type: 'Accounts' as const,
                id: _id.toString(),
              })),
              { type: 'Accounts', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Accounts', id: 'PARTIAL-LIST' }],
    }),
  }),
});

export const { useGetAccountsQuery, useEnsureAccountInfraMutation } =
  accountsApi;
